import React from "react";
import theme from "theme";
import { Theme, Button, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
import * as Components from "components";
import ProjectThermalStorage from "./projects_thermalstorage";
import ProjectsWindturbine from "./projects_windturbine";
import ProjectsSolarGreenhouse from "./projects_solargreenhouse";

export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="60px 0 40px 0"
        quarkly-title="Section_ProjectsPage_Title"
      >
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          flex-direction="column"
          justify-content="center"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
            text-align="center"
          >
            We have three major projects: Net-Zero Solar Greenhouse,
            Savonius-style Wind Turbine, and PCM Thermal Storage
          </Text>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            Each with descriptions, latest articles, and notable articles.
          </Text>
          <Box
            md-width="100%"
            empty-min-width="64px"
            empty-min-height="64px"
            empty-border-width="1px"
            empty-border-style="solid"
            empty-border-color="LightGray"
            width="100%"
            align-self="flex-start"
            flex="1 1 0%"
            align-items="center"
            justify-content="center"
            flex-direction="row"
            flex-wrap="no-wrap"
            display="flex"
          >
            <Text
              color="--light"
              font="--base"
              lg-font='normal 400 16px/1.5 "Varta", sans-serif'
              margin="0px 0px 0px 0px"
              text-align="center"
              display="block"
              padding="0px 0px 20px 0px"
              flex="0 0 auto"
            >
              <br />
              (Or, check our all our articles here:{"  "}
            </Text>
            <Button
              color="--light"
              padding="12px 36px 12px 36px"
              background="linear-gradient(180deg,--color-green 0%,#1e1616 100%) 0 0 no-repeat"
              border-radius="32px"
              type="link"
              href="/articles"
              text-decoration-line="initial"
            >
              Articles
            </Button>
            <Text
              color="--light"
              font="--base"
              lg-font='normal 400 16px/1.5 "Varta", sans-serif'
              margin="0px 0px 0px 0px"
              text-align="center"
              display="block"
              padding="0px 0px 20px 0px"
              flex="0 0 auto"
            >
              <br />
              {"  "}){"  "}
            </Text>
          </Box>
        </Box>
      </Section>
      <ProjectsSolarGreenhouse />
      <ProjectsWindturbine />
      <ProjectThermalStorage />
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
